import { DataField, type DashboardLayout } from '@edge/spark/io-dashboards'

export const DefaultCompanyCardLayout: DashboardLayout = {
    id: '921cb4d0-1ede-4af4-b3e6-a0bc23b3198e',
    version: 1,
    name: 'Company Information',
    cards: [
        {
            id: '42038e67-f79b-4547-a0ff-28bd965c61fb',
            type: 'SearchCard',
            width: 1,
            height: 1,
            config: {
                title: 'Inventory',
                label: 'In Inventory',
                label2: '',
                linklabel: 'ACCOUNT VEHICLES',
                linkurl: '/searchdetails/account-vehicles-inventory',
                search: {
                    searchString: 'status:inventory <selleraccountid>:<company:id>',
                    primary: {
                        dataField: DataField.TOTAL,
                        rightLabel: '',
                    },
                    searchDetailView: 'Vehicles',
                    searchDetailTitle: 'Inventory for <company.name.id>',
                },
            },
        },
        {
            id: '6d988d84-820c-4a7b-9267-23271a44b997',
            type: 'SearchCard',
            width: 1,
            height: 1,
            config: {
                title: 'Consigned',
                label: 'Last 30 days',
                label2: '',
                linklabel: 'ACCOUNT VEHICLES',
                linkurl: '/searchdetails/account-vehicles-consigned',
                search: {
                    searchString: 'saledate:30 <selleraccountid>:<company:id>',
                    primary: {
                        dataField: DataField.TOTAL,
                        rightLabel: '',
                    },
                    searchDetailView: 'Vehicles',
                    searchDetailTitle: 'Consigned Vehicles Last 30 Days for <company.name.id>',
                },
            },
        },
        {
            id: '6d988d84-820c-4a7b-9267-23271a44b996',
            type: 'SearchCard',
            width: 1,
            height: 1,
            config: {
                title: 'Sold',
                label: 'Sold',
                sublabel: 'in the last 30 days',
                label2: '',
                linklabel: 'ACCOUNT VEHICLES SOLD',
                linkurl: '/searchdetails/customcard/account-vehicles-sold',
                search: {
                    primary: { dataField: DataField.SOLD, rightLabel: '' },
                    lowerLeft: {
                        dataField: DataField.RAN,
                        leftLabel: 'Ran: ',
                        rightLabel: '',
                    },
                    lowerRight: {
                        dataField: DataField.CONVERSION,
                        leftLabel: 'Conversion: ',
                        rightLabel: '%',
                    },
                    searchString: 'status:sold,offer,arbitration saledate:30 <selleraccountid>:<company:id>',
                    searchDetailView: 'Deals',
                    searchDetailTitle: 'Sold Vehicles Last 30 Days for <company.name.id>',
                },
            },
        },
        {
            id: '2ef1092a-dd21-4078-9a38-32f8a6663cb7',
            type: 'SearchCard',
            width: 1,
            height: 1,
            config: {
                title: 'Purchased',
                label: 'Last 30 days',
                label2: '',
                linklabel: 'ACCOUNT VEHICLES BOUGHT',
                linkurl: '/searchdetails/customcard/account-vehicles-bought',
                search: {
                    searchString: 'saledate:30 status:sold,offer,arbitration <buyeraccountid>:<company:id>',
                    primary: {
                        dataField: DataField.TOTAL,
                        rightLabel: '',
                    },
                    lowerRight: {
                        dataField: DataField.AVG_SALE_AMOUNT,
                        leftLabel: 'Average Sale',
                        rightLabel: '',
                    },
                    lowerLeft: {
                        dataField: DataField.SUM_SALE_AMOUNT,
                        leftLabel: 'Sum of Sales',
                        rightLabel: '',
                    },
                    searchDetailView: 'Deals',
                    searchDetailTitle: 'Purchased Vehicles Last 30 Days for <company.name.id>',
                },
            },
        },
        {
            id: 'dba8db7c-073a-48d7-9074-f05336593851',
            type: 'SearchCard',
            width: 1,
            height: 1,
            config: {
                title: 'Sold - No Title',
                label: 'Total Cars',
                label2: '',
                linklabel: 'ACCOUNT VEHICLES SOLD',
                linkurl: '/searchdetails/customcard/account-vehicles-notitles',
                search: {
                    searchString: 'status:sold <selleraccountid>:<company:id> title:no',
                    primary: {
                        dataField: DataField.TOTAL,
                        rightLabel: '',
                    },
                    searchDetailView: 'Vehicles',
                    searchDetailTitle: 'Sold - No Title <company.name.id>',
                },
            },
        },
        {
            id: '0c561ad0-bc87-44bc-9994-02add763fb57',
            type: 'SearchCard',
            width: 1,
            height: 1,
            config: {
                title: 'Inventory at Dealer',
                label: 'Total Cars',
                label2: '',
                linklabel: 'VIEW VEHICLES (DMS)',
                linkurl: '/searchdetails/customcard/vehicle-dealer',
                search: {
                    searchString: 'feed:dms new:no <selleraccountid>:<company:id>',
                    primary: {
                        dataField: DataField.TOTAL,
                        rightLabel: '',
                    },
                    searchDetailView: 'DMS Vehicles',
                    searchDetailTitle: 'Inventory at Dealership <company.name.id>',
                },
            },
        },
    ],
}
